import { render, staticRenderFns } from "./WhiteBlock.vue?vue&type=template&id=50454569&"
import script from "./WhiteBlock.vue?vue&type=script&lang=js&"
export * from "./WhiteBlock.vue?vue&type=script&lang=js&"
import style0 from "./WhiteBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports